const SHOPLIFT_CONTROL_ID = '019f617d-ab8d-79c0-8b32-e12580fbab58';
const SHOPLIFT_VARIANT_ID = '019f617d-b4c9-7484-a140-becb4f48f179';
const ADDITIONAL_TEXT_SELECTOR = '[data-plp-additional-green-text]';
const BOGO_TEXT_SELECTOR = '[data-plp-bogo-text]';
const SHOPLIFT_TIMEOUT = 10000;

const waitForShoplift = () => {
  const startedAt = Date.now();

  return new Promise((resolve) => {
    const check = () => {
      if (typeof window.shoplift?.isHypothesisActive === 'function') {
        resolve(window.shoplift);
        return;
      }

      if (Date.now() - startedAt >= SHOPLIFT_TIMEOUT) {
        resolve(null);
        return;
      }

      window.setTimeout(check, 50);
    };

    check();
  });
};

const swapGreenText = (root = document) => {
  const additionalTexts = [];

  if (root.nodeType === Node.ELEMENT_NODE && root.matches(ADDITIONAL_TEXT_SELECTOR)) {
    additionalTexts.push(root);
  }

  additionalTexts.push(...root.querySelectorAll(ADDITIONAL_TEXT_SELECTOR));

  additionalTexts.forEach((additionalText) => {
    const container = additionalText.parentElement;
    if (!container) return;

    container.querySelectorAll(BOGO_TEXT_SELECTOR).forEach((bogoText) => {
      bogoText.style.display = bogoText === additionalText ? 'block' : 'none';
    });
  });
};

const setupPLPGreenTextTest = async () => {
  const shoplift = await waitForShoplift();
  if (!shoplift) return;

  try {
    const isVariant = await shoplift.isHypothesisActive(SHOPLIFT_VARIANT_ID);

    if (!isVariant) {
      await shoplift.isHypothesisActive(SHOPLIFT_CONTROL_ID);
      return;
    }

    swapGreenText();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) swapGreenText(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  } catch (error) {}
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupPLPGreenTextTest);
} else {
  setupPLPGreenTextTest();
}
